import { render, staticRenderFns } from "./PromotionTag.vue?vue&type=template&id=27ca561e&lang=pug"
import script from "./PromotionTag.vue?vue&type=script&lang=js"
export * from "./PromotionTag.vue?vue&type=script&lang=js"
import style0 from "./PromotionTag.vue?vue&type=style&index=0&id=27ca561e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports